module.exports = __webpack_public_path__ + "static/media/project_5.e1de7412.png";